import { ErrorOutline } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Container, StyledDescription } from './styled';

const StatisticsError = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <ErrorOutline color="error" />
      <StyledDescription color="error">
        {t('messages:error:unknown')}
      </StyledDescription>
    </Container>
  );
};

export default StatisticsError;
